import axios from "axios";
import { API } from "@/lib/api";

const TOKEN_KEY = "compass_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const auth = axios.create({ baseURL: API });
auth.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
auth.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e?.response?.status === 401) clearToken();
    return Promise.reject(e);
  }
);

export async function adminLogin(password) {
  const { data } = await axios.post(`${API}/admin/login`, { password });
  setToken(data.token);
  return data;
}

export async function adminMe() {
  const { data } = await auth.get("/admin/me");
  return data;
}

export async function listSignups(filters = {}) {
  const { data } = await auth.get("/admin/signups", { params: filters });
  return data;
}

export async function patchSignup(id, patch) {
  const { data } = await auth.patch(`/admin/signups/${id}`, patch);
  return data;
}

export async function createGroup({ event, signup_ids, notes }) {
  const { data } = await auth.post("/admin/groups", { event, signup_ids, notes });
  return data;
}

export async function listGroups() {
  const { data } = await auth.get("/admin/groups");
  return data;
}

export function exportCsvUrl() {
  return `${API}/admin/signups/export.csv`;
}

export async function downloadCsv() {
  const res = await auth.get("/admin/signups/export.csv", { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "text/csv" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = "compass-signups.csv";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
